module.exports = __webpack_public_path__ + "img/two.2c9e8f11.png";